var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReminder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#FFFFFE",
    stroke: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7365 27.0073H25.4748C26.158 27.0073 26.6026 26.2886 26.2975 25.6773L25.5604 24.2004C25.3077 23.6942 25.1507 23.1457 25.0971 22.5825L24.4669 15.9532C24.3538 14.7636 23.6698 13.7031 22.6327 13.1094L22.3464 12.9455C20.6485 11.9736 18.5628 11.9736 16.8649 12.9455L16.5786 13.1094C15.5415 13.7031 14.8575 14.7636 14.7444 15.9532L14.1142 22.5825C14.0607 23.1457 13.9036 23.6942 13.6509 24.2004L12.9138 25.6773C12.6087 26.2886 13.0533 27.0073 13.7365 27.0073Z",
    stroke: "#DDDDDD",
    strokeWidth: 0.9375
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.915 29.5233H23.2707",
    stroke: "#DDDDDD",
    strokeWidth: 0.9375,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6094 9.53809V11.8361",
    stroke: "#DDDDDD",
    strokeWidth: 0.9375,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminder);
export default __webpack_public_path__ + "static/media/reminder.528ffebcd471112660b3e40a7bad8e00.svg";
export { ForwardRef as ReactComponent };